import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'ANAPEND' },
    { value: 2, label: 'EPIPEN' },
  ],
});
